import { useContext } from "react";
import {
  MdAdminPanelSettings,
  MdArrowOutward,
  MdCreditScore,
  MdEditDocument,
  MdGroups2,
  MdPayments,
  MdPointOfSale,
  MdReport,
  MdSpaceDashboard,
  MdTwoWheeler,
} from "react-icons/md";
import { AppContext } from "../App";
import { formatAdminRole, getAllowedNavItems } from "../accessControl";
import logo_icon from "../assets/logo_icon.png";
import logo_worded from "../assets/logo_worded.png";

export default function SideBar(props) {
  const appContext = useContext(AppContext);
  const currentUser = appContext.currentUserData;
  const displayName = currentUser?.fullname || currentUser?.name || "Admin team";
  const roleLabel = formatAdminRole(currentUser?.role);
  const avatarInitial = String(displayName || "A").charAt(0).toUpperCase();

  const navItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      description: "Overview and activity",
      icon: MdSpaceDashboard,
    },
    {
      key: "customers",
      label: "Customers",
      description: "Profiles and relationships",
      icon: MdGroups2,
    },
    {
      key: "motorcycles",
      label: "Motorcycles",
      description: "Inventory and availability",
      icon: MdTwoWheeler,
    },
    {
      key: "sales",
      label: "Sales",
      description: "Transactions and performance",
      icon: MdPointOfSale,
    },
    {
      key: "debts",
      label: "Debts",
      description: "Loan tracking and balances",
      icon: MdCreditScore,
    },
    {
      key: "payments",
      label: "Payments",
      description: "Collections and receipts",
      icon: MdPayments,
    },{
      key: "reports",
      label: "Reports",
      description: "Analytics and insights",
      icon: MdEditDocument,
    },
    {
      key: "admins",
      label: "System Users",
      description: "Team access and roles",
      icon: MdAdminPanelSettings,
    },
  ];

  const allowedNavItems = getAllowedNavItems(appContext.currentUserData);
  const visibleNavItems = navItems.filter((item) => allowedNavItems.includes(item.key));

  return (
    <div className="SideBar" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
          <div className="sidebar-shell">
            <div className=" d-flex d-md-none">
              <div className="sidebar-brand-top">
                <div className="sidebar-brand-mark d-none flex-column align-items-center">
                  <img src={logo_icon} alt="Bob Admin" />
                  <img src={logo_worded} alt="Bob Admin" />
                </div>
              </div>

              <div className="sidebar-user-card">
                <div className="sidebar-user-avatar" aria-hidden="true">
                  {avatarInitial}
                </div>

                <div className="sidebar-user-copy">
                  <strong>{displayName}</strong>
                  <span>{roleLabel}</span>
                </div>
              </div>
            </div>

            <div className="sidebar-nav mt-3">
              {visibleNavItems.map((item) => {
                const Icon = item.icon;

                return (
                  <button
                    key={item.key}
                    type="button"
                    className="pill"
                    onClick={() => {
                      appContext.navTo({
                        item: item.key,
                      });
                      appContext.setIsSideBarOpen(false);
                    }}
                    data-active={appContext.navItem === item.key}
                  >
                    <span className="icon" aria-hidden="true">
                      <Icon />
                    </span>

                    <span className="nav-copy">
                      <span className="text">{item.label}</span>
                    </span>

                    <span className="nav-arrow" aria-hidden="true">
                      <MdArrowOutward />
                    </span>
                  </button>
                );
              })}
            </div>

          </div>
      </div>
    </div>
  );
}
